/** Render persisted split references against the current Lumen environment, including older Gitea links. */
export const lumenSplitLinks = (body: string): string => body
  .replace(/\[((?:SI - issue|Original issue) #(\d+))\]\(https?:\/\/[^\s)]+\)/g,
    (_match, label, number) => `[${label}](/gitea?issue=${number})`)
  .replace(/(Split off into|Split from) #(\d+)\./g,
    (_match, prefix, number) => `${prefix} [#${number}](/gitea?issue=${number}).`);
